<template>
  <div class="data-total-wrap">
    <div class="header">
      <div class="header-title">
        数据总览 /
        <el-popover
          popper-class="tools-data-search-template"
          ref="popverTemplate"
          placement="bottom-start"
          title=""
          width="500"
          trigger="click"
          @hide="hidePopver"
        >
          <div class="search-template">
            <div v-if="templateList.length > 0">
              <div class="top" v-if="operateMode === 'delete'">
                <span class="top-title">{{ selectedObj.templateName }}</span>
                <div class="button-group">
                  <el-button type="text" @click="operateMode = ''">取消</el-button>
                  <el-button style="height: 26px" type="danger" @click="deleteTemplate">删除</el-button>
                </div>
              </div>
              <div class="top" v-else-if="operateMode === 'edit'">
                <el-input style="flex: 1" v-model="editData.templateName" placeholder="请输入内容"></el-input>
                <div class="button-group">
                  <el-button type="text" @click="handleCancel">取消</el-button>
                  <el-button style="height: 26px" type="primary" @click="handleEdit('edit')">保存</el-button>
                </div>
              </div>
              <div class="top" v-else>
                <span class="top-title">{{ selectedObj.templateName }}</span>
                <div>
                  <el-tooltip class="item" effect="dark" content="删除" placement="top">
                    <i v-show="!selectedObj.isDefault" class="el-icon-delete icon" @click="operateMode = 'delete'"></i>
                  </el-tooltip>
                  <el-tooltip class="item" effect="dark" content="默认" placement="top">
                    <i class="el-icon-star-on icon" v-if="selectedObj.isCollection" @click="handleEdit('default')"></i>
                    <i class="el-icon-star-off icon" v-else @click="handleEdit('default')"></i>
                  </el-tooltip>
                  <el-tooltip class="item" effect="dark" content="重命名" placement="top">
                    <i v-show="!selectedObj.isDefault" class="el-icon-edit icon" @click="renameSearch"></i>
                  </el-tooltip>
                  <el-tooltip class="item" effect="dark" content="保存更改" placement="top">
                    <i v-show="!selectedObj.isDefault" @click="handleSaveChange" class="el-icon-document-checked icon"></i>
                  </el-tooltip>
                  <el-tooltip class="item" effect="dark" content="系统默认" placement="top">
                    <i v-show="selectedObj.isDefault" class="el-icon-s-flag icon"></i>
                  </el-tooltip>
                </div>
              </div>
              <el-divider></el-divider>
            </div>

            <div class="bottom">
              <el-button v-if="operateMode !== 'add'" class="add-search" type="text" @click="addTemplate">+ 保存新报告</el-button>
              <div style="display: flex; padding: 12px 16px 2px 16px" v-else>
                <el-input style="flex: 1" v-model="addData.templateName" placeholder="为面板命名"></el-input>
                <div style="width: 180px; text-align: right">
                  <el-button type="text" @click="operateMode = ''">取消</el-button>
                  <el-button style="height: 26px" type="primary" @click="handleSaveTemplate">保存</el-button>
                </div>
              </div>
              <div class="list">
                <div
                  v-for="item in templateList"
                  :key="item.id"
                  class="list-item"
                  @click="changeTemplate(item)"
                  :class="{ 'selected-item': item.id === selectedObj.id }"
                >
                  <div class="name">{{ item.templateName }}</div>
                  <i class="el-icon-star-on icon" v-if="item.isCollection"></i>
                  <i class="el-icon-s-flag icon" style="margin-left: 8px" v-if="item.isDefault"></i>
                </div>
              </div>
            </div>
          </div>
          <span slot="reference" class="selected-filter">{{ selectedObj.templateName }} <i class="el-icon-caret-bottom"></i></span>
        </el-popover>
      </div>
      <filter-header @searchData="searchData" :filterData.sync="filterData"></filter-header>
    </div>

    <total-card ref="totalCard" :filterData="filterData"></total-card>
    <charts-line ref="chartsLine" :chartFilter.sync="chartFilter" :topFilterData="filterData"></charts-line>
    <data-table ref="dataTable" :tableFilter.sync="tableFilter" :filterData="filterData"></data-table>
  </div>
</template>

<script>
import FilterHeader from "./filterHeader.vue";
import TotalCard from "./totalCard.vue";
import ChartsLine from "./charts.vue";
import DataTable from "./dataTable.vue";
import { getAllConvertTemplate, addConvertTemplate, delConvertTemplate, modifyConvertTemplate } from "@/api/tools";
import moment from "moment";

export default {
  name: "DataTotal",
  components: {
    FilterHeader,
    TotalCard,
    ChartsLine,
    DataTable,
  },
  data() {
    return {
      filterData: {
        pkg: -1,
        platType: -1,
        advertiserId: null,
        campaignId: null,
        time: [moment().subtract(7, "days").format("YYYYMMDD"), moment().subtract(1, "days").format("YYYYMMDD")],
      },
      chartFilter: undefined,
      tableFilter: undefined,
      resData: null,
      templateList: [],
      selectedObj: {},
      operateMode: "",
      editData: null,
      addData: {
        templateName: "",
      },
    };
  },
  mounted() {
    this.getTemplateList();
  },
  methods: {
    getTemplateList() {
      getAllConvertTemplate().then((res) => {
        this.templateList = res.data;
        const defaultTemplate = res.data.find((item) => item.isDefault === 1) || {};
        const collectTemplate = res.data.find((item) => item.isCollection === 1) || {};
        if (res.data.length > 1) {
          const obj = res.data.find((item) => item.id == this.selectedObj.id) || {};
          this.selectedObj = obj.id ? obj : collectTemplate.id ? collectTemplate : defaultTemplate;
        } else {
          this.selectedObj = defaultTemplate;
        }
        if (this.selectedObj.templateData) {
          const { chartFilter, tableFilter, filterData } = JSON.parse(this.selectedObj.templateData || {});
          this.chartFilter = chartFilter;
          this.tableFilter = tableFilter;
          this.filterData = filterData;
        } else {
          this.filterData = {
            pkg: -1,
            platType: -1,
            advertiserId: null,
            campaignId: null,
            time: [moment().subtract(7, "days").format("YYYYMMDD"), moment().subtract(1, "days").format("YYYYMMDD")],
          };
          this.chartFilter = undefined;
          this.tableFilter = undefined;
        }
        this.searchData();
      });
    },
    hidePopver() {
      this.operateMode = "";
      this.editData = null;
      this.addData = {
        templateName: "",
      };
    },
    changeTemplate(item) {
      this.selectedObj = item;
      this.$refs.popverTemplate.doClose();
      this.getTemplateList();
    },
    renameSearch() {
      this.editData = JSON.parse(JSON.stringify(this.selectedObj));
      this.operateMode = "edit";
    },
    handleCancel() {
      this.operateMode = "";
      this.editData = null;
    },
    handleEdit(type) {
      const obj = type === "edit" ? this.editData : this.selectedObj;
      const { templateData, templateName, id, isCollection } = obj;
      modifyConvertTemplate({
        isCollection: type === "edit" ? isCollection : isCollection === 0 ? 1 : 0,
        templateData,
        templateName,
        id,
      }).then((res) => {
        if (res.code === "0000") {
          this.$message.success(type === "edit" ? "编辑成功" : "默认设置成功");
          this.getTemplateList();
          this.$refs.popverTemplate.doClose();
        }
      });
    },
    addTemplate() {
      this.addData = {
        templateName: "",
        templateData: "",
        isCollection: 0,
      };
      this.operateMode = "add";
    },
    handleSaveTemplate() {
      addConvertTemplate({
        ...this.addData,
      }).then(() => {
        this.getTemplateList();
        this.$refs.popverTemplate.doClose();
      });
    },
    deleteTemplate() {
      delConvertTemplate({
        id: this.selectedObj.id,
      }).then((res) => {
        if (res.code === "0000") {
          this.$message.success("删除成功");
          this.getTemplateList();
          this.selectedObj = this.templateList[0];
          this.$refs.popverTemplate.doClose();
        }
      });
    },
    handleSaveChange() {
      const data = {
        chartFilter: this.chartFilter,
        tableFilter: this.tableFilter,
        filterData: this.filterData,
      };
      const { templateName, id, isCollection } = this.selectedObj;
      modifyConvertTemplate({
        isCollection,
        templateData: JSON.stringify(data),
        templateName,
        id,
      }).then((res) => {
        if (res.code === "0000") {
          this.$message.success("保存成功");
          this.getTemplateList();
          this.$refs.popverTemplate.doClose();
        }
      });
    },
    searchData() {
      this.$refs.chartsLine.searchData(this.filterData);
      this.$refs.dataTable.searchData(this.filterData);
      this.$refs.totalCard.searchData(this.filterData);
    },
  },
};
</script>

<style lang="less" scoped>
.data-total-wrap {
  padding: 16px;
  box-sizing: border-box;
  height: 100%;
  overflow: auto;
  .header {
    align-items: center;
    padding: 15px 24px;
    border-radius: 4px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
    margin-bottom: 16px;
    .header-title {
      font-weight: 600;
      .selected-filter {
        cursor: pointer;
      }
    }
  }
}
</style>
<style lang="less">
.tools-data-search-template {
  padding: 0px;
  .search-template {
    .top {
      display: flex;
      padding: 14px 12px 0 12px;
      height: 32px;
      line-height: 32px;
      .button-group {
        position: relative;
        top: -5px;
        width: 180px;
        text-align: right;
        .el-button--danger {
          font-size: 14px;
          border-radius: 2px;
          color: #ffffff;
          padding: 0px 9px;
        }
      }
      &-title {
        display: inline-block;
        flex: 1;
      }
      .icon {
        cursor: pointer;
        margin-left: 12px;
        font-size: 18px;
      }
    }
    .el-divider--horizontal {
      margin: 12px 0 0 0;
    }
    .bottom {
      .add-search {
        margin-left: 20px;
      }
      .list {
        max-height: 300px;
        overflow-y: auto;
        .list-item {
          display: flex;
          height: 40px;
          line-height: 40px;
          padding: 0 20px;
          cursor: pointer;
          .name {
            flex: 1;
          }
          .icon {
            font-size: 18px;
            line-height: 40px;
          }
        }
        .list-item:hover {
          background: #f2f6fc;
        }
        .selected-item {
          background: #ebeef5 !important;
        }
      }
    }
  }
}
</style>
